import './index.less';

import classNames from 'classnames';
import { lazy, Suspense, useEffect, useState } from 'react';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import { SecurityProvider } from '@/content/security-store';
import { useI18nContext } from '@/i18n/I18n';
import isApp, { isMobile } from '@/utils/ua';

const LazyEntry = lazy(() => import('./lazyEntry'));

/*
  用户携带email_verify_token进来，并且Cookie中有登录态就显示IsLoginPanel
  并且调用接口，获取用户信息
*/
const AutoBanAccount = () => {
  const [$t] = useI18nContext();
  const [theme, setTheme] = useState<number>(1);

  const getTheme = async () => {
    const { default: Hecate } = await import('@bybit/hecate');
    await Hecate.ready();
    Hecate.SystemInfo.getTheme({}).then((res: any) => {
      const theme = res.params ? res.params.theme : 1;

      if (theme == 1) {
        (document.querySelector('html') as any).className = 'moly-theme-dark';
      }
      setTheme(theme);
    });
  };

  useEffect(() => {
    document.title = $t('autoBanAccount');
    if (isApp()) {
      getTheme();
    }
  }, [$t('autoBanAccount')]);

  return (
    <div
      className={classNames('custom-ban-user', {
        'custom-ban-user-dark': theme == 1,
      })}
    >
      <SecurityProvider>
        {isApp() || isMobile() ? (
          <></>
        ) : (
          <PageHeader
            pageLevel={PageLevel.sub}
            breadItems={[
              {
                key: '1',
                label: () => (
                  <a
                    className="no-underline text-inherit"
                    href="/app/user/account-info"
                  >
                    {$t('accountBaseInfo') || 'Account Info'}
                  </a>
                ),
              },
              {
                key: '2',
                title: $t('autoBanAccount'),
              },
            ]}
          />
        )}

        <div className="breadcrumb breadcrumb-custom">
          <span data-paint>{$t('security') || 'Security'}</span>
        </div>
        <Suspense fallback="">
          <LazyEntry theme={theme} />
        </Suspense>
      </SecurityProvider>
    </div>
  );
};

export default AutoBanAccount;
